import Home from "./Home/Home";
import Setting from "./Setting/Setting";
import Camera from "./Camera/Camera";
import SignIn from "./SignIn/Signin";
import FlagBagList from "./FlagBagList/FlagBagList";
interface Route {
	path: string;
	type?: "auth" | "unauth";
	renderer: (params?: Record<string, any>) => JSX.Element;
}

const routes: Route[] = [
	{
		path: "sign-in",
		type: "unauth",
		renderer: (params = {}): JSX.Element => <SignIn {...params} />,
	},
	{
		path: "/",
		type: "auth",
		renderer: (params = {}): JSX.Element => <Home {...params} />,
	},
	{
		path: "/bag-list",
		type: "auth",
		renderer: (params = {}): JSX.Element => <FlagBagList {...params} />,
	},

	{
		path: "/setting",
		type: "auth",
		renderer: (params = {}): JSX.Element => <Setting {...params} />,
	},
	{
		path: "/camera",
		type: "auth",
		renderer: (params = {}): JSX.Element => <Camera {...params} />,
	},
];

export default routes;
